<template>
  <div v-if="visible">
    <!-- 全屏 loading spinner -->
    <div v-if="!inline" class="spinner-container">
      <div class="spinner">
        <div v-for="n in 8" :key="n" class="spinner-dot" :style="getStyle(n)"></div>
      </div>
    </div>
    
    <!-- 内联 loading spinner -->
    <div v-else class="inline-spinner">
      <svg class="spinner-icon" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none" stroke-dasharray="31.416" stroke-dashoffset="31.416">
          <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
          <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
        </circle>
      </svg>
      <span v-if="text" class="spinner-text">{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    }
  },
  methods: {
    getStyle(index) {
      const angle = (index - 1) * 45;
      return {
        transform: `rotate(${angle}deg) translate(0, -12px)`
      };
    }
  }
};
</script>

<style scoped>
/* 全屏 loading spinner 样式 */
.spinner-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.85); /* 改为半透明白色背景 */
  backdrop-filter: blur(2px); /* 添加轻微模糊效果 */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  transition: opacity 0.3s ease; /* 添加淡入淡出效果 */
}

.spinner {
  position: relative;
  width: 40px; /* 从60px减小到40px */
  height: 40px; /* 从60px减小到40px */
  animation: spin 1s linear infinite;
}

.spinner-dot {
  width: 6px; /* 从10px减小到6px */
  height: 6px; /* 从10px减小到6px */
  background-color: #2e3968; /* 改为主题色 */
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -3px 0 0 -3px; /* 从-5px调整为-3px */
  box-shadow: 0 1px 2px rgba(46, 57, 104, 0.2); /* 减小阴影 */
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

/* 内联 loading spinner 样式 */
.inline-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.spinner-icon {
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
}

.spinner-text {
  font-size: 14px;
  color: inherit;
}
</style>
  